var memoize = require('memoize-weak');

module.exports = memoize(function bind(fn, context) {
  var args = Array.prototype.slice.call(arguments, 2);
  return Function.prototype.bind.apply(fn, [context].concat(args));
});



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/socialtravel/shared/~/memoize-bind/lib/bind.js
// module id = 997
// module chunks = 0